import EVENTS from "../constants/events";
import generateEventPair from "../helpers/generateEventPair";

export const {
  dispatcher: dispatchListingProgressChanged,
  responder: respondToListingProgressChanged
} = generateEventPair({
  eventName: EVENTS.PROGRESS_CHANGED,
  signatureParams: ["listingId", "listingType"]
});
